import type { ResolvedEditorElement } from '@wix/component-protocol/resolver';
import type { ResolvedInnerElement } from '@wix/editor-platform-manifest-services';

export type BuilderPreset = {
  id: string;
  name: string;
  src: string;
};

export function getPresets(
  _: ResolvedEditorElement | ResolvedInnerElement | null,
): BuilderPreset[] | null {
  return null;
}
